import { render } from "./IndexProjectUsersPage.vue?vue&type=template&id=03774857"
import script from "./IndexProjectUsersPage.vue?vue&type=script&lang=js"
export * from "./IndexProjectUsersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__